<!-- eslint-disable no-unreachable -->
<template>
    <ion-page>
        <ion-header class="ion-no-border">
            <ion-toolbar color="light">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="cancel">
                        <ion-icon slot="icon-only" :icon="close"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Nieuw component</ion-title>
                <ion-buttons slot="end">
                    <ion-button v-if="!loading && selected" color="primary" @click="confirm()">
                        <mdicon name="content-save"></mdicon>
                    </ion-button>

                    <!-- else we show spinner -->
                    <ion-button v-else-if="loading" color="primary">
                        <ion-spinner name="crescent"></ion-spinner>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content color="light">
            <list :inset="true" v-if="!selected" :show_search="true" @open="selectComponent" @new="newComponent" :max_items="20" :item_size="50" :no_created_at="true" last_searched_section="components" :is_parent="parent" :loading="loading">
                <template v-slot:no-data>
                    <p class="no-data-title">Geen componenten gevonden</p>
                    <p class="no-data-subtitle">
                        Staat het apparaat dat je zoekt niet in de lijst? Vraag de beheerder om deze toe te voegen.
                    </p>
                </template>
            </list>
            <div v-show="selected">
                <!-- choose other component (selected is null) -->
                <ion-button class="mt-4" size="small" @click="selected = false" fill="clear" color="primary">
                    <mdicon name="chevron-left"></mdicon>
                    Kies een ander component
                </ion-button>

                <PreSuffixInclude :component="selected_component" @update="parent_components = $event">
                </PreSuffixInclude>

                <ion-list :inset="true" lines="inset" v-if="$store.getters.checkSetting('measurements')">
                    <ion-list-header class="small-list-header">
                        <ion-label class="my-0">Metingen klaarzetten</ion-label>
                    </ion-list-header>
                    <ion-item>
                        <ion-label>Metingen toevoegen aan {{ selected_component.name }}?</ion-label>
                        <ion-toggle v-model="add_measurements"></ion-toggle>
                    </ion-item>
                    <transition name="level">
                        <ion-list v-show="add_measurements">
                            <ion-item>
                                <ion-label position="stacked">Metingen toevoegen</ion-label>
                                <ion-select interface="action-sheet" ref="measurements_parent" mode="ios" :multiple="true" placeholder="Selecteer metingen" okText="Kies" cancelText="Annuleren" v-model="selected_measurement_types">
                                    <ion-select-option :value="measurement_type" v-for="(measurement_type, index) in getMeasurementTypes" :key="index">
                                        {{ measurement_type.name }}</ion-select-option>
                                </ion-select>
                            </ion-item>
                        </ion-list>
                    </transition>

                </ion-list>

                <ion-list :inset="true" v-if="selected && selected_component.attributes">
                    <ion-list-header class="small-list-header">
                        <ion-label class="my-0">Attributen</ion-label>
                    </ion-list-header>

                    <Attributes :rules="selected_component.attributes" :component_uuid="selected_component.uuid" @updateFields="setFields">
                    </Attributes>
                </ion-list>

                <template v-if="selected_component && selected_component.parent">
                    <ion-list :inset="true" lines="inset">
                        <ion-item class="input-right-align">
                            <ion-label>Subcomponenten toevoegen?</ion-label>
                            <ion-toggle v-model="add_subcomponents"></ion-toggle>
                        </ion-item>


                        <template v-if="add_subcomponents">

                            <div v-show="!sub_selected">
                                <RowSelectModal ref="row_select" :max_items="20" :items="all_components" label="Selecteer subcomponent" field_name="name" @change="selectSubComponent" :showCreateButton="true" :fullscreen="true">
                                </RowSelectModal>
                            </div>

                        </template>
                    </ion-list>

                    <template v-if="sub_selected && add_subcomponents">
                        <PreSuffixInclude :component="selected_subcomponent" @update="this.sub_components = $event">
                        </PreSuffixInclude>


                        <ion-list :inset="true" v-if="sub_selected && selected_subcomponent?.attributes">
                            <ion-list-header class="small-list-header">
                                <ion-label class="my-0">Attributen</ion-label>
                            </ion-list-header>
                            <Attributes :rules="selected_subcomponent.attributes" :component_uuid="selected_subcomponent.uuid" @updateFields="setFieldsSub" :no_list="true">
                            </Attributes>
                        </ion-list>
                    </template>


                    <ion-list :inset="true" v-if="add_subcomponents && $store.getters.checkSetting('measurements')">
                        <ion-list-header class="small-list-header">
                            <ion-label class="my-0">Metingen klaarzetten</ion-label>
                        </ion-list-header>
                        <ion-item v-if="$store.getters.checkSetting('measurements')">
                            <ion-label>Metingen toevoegen?</ion-label>
                            <ion-toggle v-model="add_measurements_s"></ion-toggle>
                        </ion-item>
                        <transition name="level">
                            <ion-list v-if="add_measurements_s">
                                <ion-item>
                                    <ion-label position="stacked">Metingtypes</ion-label>
                                    <ion-select mode="ios" :multiple="true" placeholder="Selecteer metingen" okText="Kies" cancelText="Annuleren" v-model="selected_measurement_types_s">
                                        <ion-select-option :value="measurement_type" v-for="(measurement_type, index) in getMeasurementTypes" :key="index">
                                            {{ measurement_type.name }}</ion-select-option>
                                    </ion-select>
                                </ion-item>
                            </ion-list>
                        </transition>
                    </ion-list>
                </template>
            </div>
        </ion-content>
    </ion-page>
</template>
<script>
import { modalController } from "@ionic/vue";
import {
    add,
    list,
    albumsOutline,
    save,
    camera,
    informationCircle,
    ellipsisVertical,
    calculator,
    chevronBack,
    trash,
    close,
    chevronForward,
} from "ionicons/icons";

import uuid from "@/plugins/uuid";
import List from "@/components/ComponentList.vue";
import { db } from "@/services/db";
import module_parser from "@/services/module_parser";
import RowSelectModal from "@/components/RowSelectModal.vue";
import Attributes from "./include/Attributes.vue";
import PreSuffixInclude from "../../components/PreSuffixInclude.vue";
import { v4 as uuidv4 } from "uuid";

export default {
    name: "location-item-component-create",
    props: {
        parent_uuid: {
            type: String,
            required: false,
        },
        location_item_uuid: {
            type: String,
            required: false,
        },
        parent: {
            type: Boolean,
            required: false,
        },
        component: {
            uuid: uuidv4(),
            name: "",
            code: "",
            parent: true,
        },
    },
    components: {
        List,
        RowSelectModal,
        Attributes,
        PreSuffixInclude
    },
    data() {
        return {
            parent_components: [],
            sub_components: [],
            amount_s: 1,
            numbering_s: false,
            start_number_s: 1,
            selected_measurement_types_s: [],
            add_measurements_s: false,
            add_subcomponents: false,
            location_item_name: "",
            add,
            list,
            albumsOutline,
            save,
            chevronBack,
            camera,
            calculator,
            informationCircle,
            ellipsisVertical,
            trash,
            close,
            chevronForward,
            selected_component: {
                name: "",
                parent: null,
            },
            add_measurements: false,
            measurement_types: [],
            selected_measurement_types: [],
            amount: 1,
            numbering: false,
            start_number: 1,
            measurement_instruments: [],
            measurement_instrument_types: [],
            components: [],
            loading: true,
            location_item_component_name: "",
            selected_subcomponent: {
                name: "",
                parent: false,
            },
            all_components: [],
            selected: false,
            sub_selected: false,
            create_component: false,
        };
    },
    created() {
        this.setup();
    },
    emits: ["open"],
    methods: {
        async newComponent(component) {
            if (!this.$store.getters.checkSetting('create_component')) {
                this.$toast.error('Componenten aanmaken is uitgeschakeld')
                return
            }

            let url = '/components'
            await this.$requests.post('components', url, component, 'base_components').then(response => {
                this.selectComponent(component);
            }).catch(error => {
                this.$toast.error('Fout bij aanmaken component')
            })
        },
        setFields(fields) {
            this.selected_component.attributes.fields = fields
        },
        setFieldsSub(fields) {
            if (this.selected_subcomponent.attributes) {
                this.selected_subcomponent.attributes.fields = fields
            }
        },
        resetSelectSubComponent() {
            this.sub_selected = false;
            this.selected_subcomponent = {
                name: "",
                parent: false,
            };
            this.$refs.row_select.reset();
        },
        selectSubComponent(component) {
            this.selected_subcomponent = component;

            this.sub_selected = true;
        },
        cancel() {
            return modalController.dismiss(null, "cancel");
        },
        selectComponent(component) {
            this.selected = true;
            this.selected_component = component;
        },
        async confirm() {
            // Stap 1: Validatie
            if (this.selected_component.name.length < 1) {
                this.$toast.error("Omschrijving is verplicht");
                return;
            }

            if (this.selected_component.name.length > 150) {
                this.$toast.error("Omschrijving mag maximaal 150 tekens bevatten");
                return;
            }

            if (this.add_subcomponents) {
                if (!this.selected_subcomponent) {
                    this.$toast.error("Selecteer een subcomponent");
                    return;
                }

                if (this.selected_subcomponent.name.length < 1) {
                    this.$toast.error("Omschrijving van subcomponent is verplicht");
                    return;
                }

                if (this.selected_subcomponent.name.length > 150) {
                    this.$toast.error(
                        "Omschrijving van subcomponent mag maximaal 150 tekens bevatten"
                    );
                    return;
                }
            }

            this.loading = true;

            // Stap 2: Arrays voor nieuwe records
            let location_item_components = [];
            let location_item_subcomponents = [];
            let measurements = [];

            // Get measurement type revisions for this inspection
            const inspection = await db.inspections.get(this.$store.getters.getInspectionId);
            let measurement_type_revisions = await db.measurement_type_revisions.toArray();
            measurement_type_revisions = measurement_type_revisions.filter((mtr) =>
                inspection.measurement_type_revisions.some((imtr) => imtr.id === mtr.id)
            );

            // Helper function to get revision for a measurement_type
            const getRevisionForMeasurementType = (measurement_type) => {
                return measurement_type_revisions.find(
                    (mtr) => mtr.measurement_type_id === measurement_type.id
                );
            };

            // 2.1 Voor ieder 'parent component' maken we een nieuw location_item_component
            for (let parent_component of this.parent_components) {
                let location_item_component = {
                    location_item_uuid: this.location_item_uuid,
                    uuid: uuid(),
                    component_uuid: this.selected_component.component_uuid,
                    name: parent_component.name,
                    inspection_id: this.$store.getters.getInspectionId,
                    parent_uuid: this.parent_uuid,
                    parent: this.selected_component.parent,
                    order_id: parent_component.order_id, // wordt later nog overschreven
                    attributes: this.selected_component.attributes,
                };

                // In state openen of dicht
                let state = {
                    opened: false,
                    uuid: location_item_component.uuid,
                };
                this.$store.dispatch("setLocationItemComponentState", state);

                // Metingen toevoegen indien aangevinkt
                location_item_component.measurements = [];
                if (this.add_measurements) {
                    for (let measurement_type of this.selected_measurement_types) {
                        // Get the correct revision for this measurement_type
                        const measurement_type_revision = getRevisionForMeasurementType(measurement_type);

                        let measurement_rules = null;
                        if (measurement_type_revision) {
                            measurement_rules = await this.$convert.defineMeasurementRules(
                                measurement_type_revision.rules
                            );
                            measurement_rules.revision_id = measurement_type_revision.id;
                        }

                        let measurement = {
                            uuid: uuid(),
                            name: measurement_type.name,
                            location_item_component_uuid: location_item_component.uuid,
                            inspection_id: this.$store.getters.getInspectionId,
                            measurement_type_id: measurement_type.id,
                            rules: measurement_rules,
                            description: measurement_type.description,
                            is_defect: false,
                            measurement_instrument_ids: [],
                            remark: null,
                            danger_aspect_id: null,
                            error_indication_id: null,
                            error_classification_id: null,
                            repair_period_id: null,
                            completed: false,
                        };
                        measurements.push(measurement);
                    }
                }

                location_item_components.push(location_item_component);
            }

            // 2.2 Eventueel subcomponents
            if (this.sub_selected) {
                for (let parent_location_item_component of location_item_components) {
                    for (let sub_component of this.sub_components) {
                        let location_item_subcomponent = {
                            location_item_uuid: this.location_item_uuid,
                            uuid: uuid(),
                            component_uuid: this.selected_subcomponent.component_uuid,
                            name: sub_component.name,
                            inspection_id: this.$store.getters.getInspectionId,
                            parent_uuid: parent_location_item_component.uuid,
                            parent: false,
                            order_id: sub_component.order_id, // ook later overschreven
                            attributes: this.selected_subcomponent.attributes ?? null,
                        };

                        // Metingen bij subcomponent
                        location_item_subcomponent.measurements = [];
                        if (this.add_measurements_s) {
                            for (let measurement_type of this.selected_measurement_types_s) {
                                // Get the correct revision for this measurement_type
                                const measurement_type_revision = getRevisionForMeasurementType(measurement_type);

                                let measurement_rules = null;
                                if (measurement_type_revision) {
                                    measurement_rules = await this.$convert.defineMeasurementRules(
                                        measurement_type_revision.rules
                                    );
                                    measurement_rules.revision_id = measurement_type_revision.id;
                                }

                                let measurement = {
                                    uuid: uuid(),
                                    name: measurement_type.name,
                                    location_item_component_uuid: location_item_subcomponent.uuid,
                                    inspection_id: this.$store.getters.getInspectionId,
                                    measurement_type_id: measurement_type.id,
                                    rules: measurement_rules,
                                    description: measurement_type.description,
                                    is_defect: false,
                                    measurement_instrument_ids: [],
                                    remark: null,
                                    danger_aspect_id: null,
                                    error_indication_id: null,
                                    error_classification_id: null,
                                    repair_period_id: null,
                                    completed: false,
                                };
                                measurements.push(measurement);
                            }
                        }

                        location_item_subcomponents.push(location_item_subcomponent);
                    }
                }
            }

            // Stap 3: Bestaande LICs ophalen voor order_id
            let existing_location_item_components = await db.location_item_components
                .where("location_item_uuid")
                .equals(this.location_item_uuid)
                .toArray();

            // 3.1 Als er parent_uuid is, werken we met subcomponents
            if (this.parent_uuid) {
                let existing_location_item_subcomponents = await db.location_item_components
                    .where("parent_uuid")
                    .equals(this.parent_uuid)
                    .toArray();

                // Bepaal hoogste volgnummer (order_id)
                let highest_order_id = 0;
                if (existing_location_item_subcomponents.length > 0) {
                    highest_order_id = Math.max(
                        ...existing_location_item_subcomponents.map(o => o.order_id ?? 0)
                    );
                    if (!Number.isFinite(highest_order_id)) {
                        highest_order_id = 0;
                    }
                }

                // Verhoog order_id met 1 voor elke nieuwe subcomponent
                if (location_item_subcomponents.length > 0) {
                    for (let location_item_subcomponent of location_item_subcomponents) {
                        highest_order_id++;
                        location_item_subcomponent.order_id = highest_order_id;
                    }
                }

                // Daarna ook voor de parent components
                if (location_item_components.length > 0) {
                    for (let location_item_component of location_item_components) {
                        highest_order_id++;
                        location_item_component.order_id = highest_order_id;
                    }
                }

                // 3.2 Geen parent_uuid => directe children op deze location_item_uuid
            } else if (existing_location_item_components.length > 0) {
                // Hoogste order uit de reeds bestaande
                let highest_order_id = Math.max(
                    ...existing_location_item_components.map(o => o.order_id ?? 0)
                );
                if (!Number.isFinite(highest_order_id)) {
                    highest_order_id = 0;
                }

                if (location_item_components.length > 0) {
                    for (let location_item_component of location_item_components) {
                        highest_order_id++;
                        location_item_component.order_id = highest_order_id;
                    }
                }
            } else {
                // Helemaal niets bestaands; begin gewoon bij 0
                let highest_order_id = 0;
                if (location_item_components.length > 0) {
                    for (let location_item_component of location_item_components) {
                        highest_order_id++;
                        location_item_component.order_id = highest_order_id;
                    }
                }
            }

            // Alle components samenvoegen
            let all_components = [...location_item_components, ...location_item_subcomponents];

            // Validatie: controleer of er componenten zijn om op te slaan
            if (all_components.length === 0) {
                this.loading = false;
                this.$toast.error("Geen componenten om op te slaan");
                return;
            }

            // Stap 4: Wegschrijven naar de API (bulk create)
            let url =
                "/inspections/" +
                this.$store.getters.getInspectionId +
                "/bulk-location-item-components";
            await this.$requests.post("location_item_components", url, {
                location_item_components: all_components,
            });

            // Metingen parsen + wegschrijven
            if (measurements && measurements.length > 0) {
                let parsed_measurements = await module_parser("measurements", measurements);
                let meas_url =
                    "/inspections/" + this.$store.getters.getInspectionId + "/bulk-measurements";
                await this.$requests.post("measurements", meas_url, { measurements: parsed_measurements });
            }

            // Eventueel UI refresh
            this.$store.dispatch("setComponentCountKey");

            // Even vertraging voor de zekerheid
            await new Promise((resolve) => setTimeout(resolve, 500));

            this.loading = false;

            // Sluit de modal
            return modalController.dismiss(null, "confirm");
        },

        async setup() {
            this.loading = true;
            this.measurement_types = await db.measurement_types
                .toArray()
                .then((measurement_types) => {
                    return measurement_types.sort((a, b) =>
                        a.name.localeCompare(b.name, undefined, {
                            numeric: true,
                            sensitivity: "base",
                        })
                    );
                });

            this.components = await db.base_components.toArray().then((components) => {
                // If there's no parent_uuid, filter components where 'parent' is true
                if (this.parent) {
                    components = components.filter((component) => component.parent === true);
                } else {
                    // If parent_uuid is provided, filter components where 'parent' is false
                    components = components.filter((component) => component.parent === false);
                }

                return components.sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
                );
            });

            this.all_components = await db.base_components.toArray().then((components) => {
                components = components.filter((component) => component.parent === false);

                return components.sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
                );
            });

            this.location_item_name = await db.location_items
                .where("uuid")
                .equals(this.location_item_uuid)
                .first()
                .then((location_item) => {
                    return location_item.name;
                });

            if (this.parent_uuid) {
                this.location_item_component_name = await db.location_item_components
                    .where("uuid")
                    .equals(this.parent_uuid)
                    .first()
                    .then((location_item_component) => {
                        return location_item_component.name;
                    });
            }

            this.loading = false;
        },
        presetMeasurementTypes() {
            if (this.selected) {
                this.selected_measurement_types = this.measurement_types.filter(
                    (measurement_type) => {
                        let component_ids = measurement_type.components.map((component) => {
                            return component.uuid;
                        });
                        return component_ids.includes(this.selected_component.uuid);
                    }
                );

                if (this.selected_measurement_types.length > 0) {
                    this.add_measurements = true;
                }
            }
        },
        presetMeasurementTypesS() {
            if (this.selected_subcomponent) {
                this.selected_measurement_types_s = this.measurement_types.filter(
                    (measurement_type) => {
                        let component_ids = measurement_type.components.map((component) => {
                            return component.uuid;
                        });
                        return component_ids.includes(this.selected_subcomponent.uuid);
                    }
                );

                if (this.selected_measurement_types_s.length > 0) {
                    this.add_measurements_s = true;
                }
            }
        },
    },
    computed: {
        getComponents() {
            let sorted = this.components

            sorted.sort((a, b) => {
                return new Date(b.created_at) - new Date(a.created_at);
            });

            return sorted;
        },
        getMeasurementTypes() {
            return this.measurement_types;
        },
    },
    watch: {
        selected: {
            handler() {
                this.presetMeasurementTypes();
            },
            deep: true,
        },
        selected_subcomponent: {
            handler() {
                this.presetMeasurementTypesS();
            },
            deep: true,
        },
        add_subcomponents: {
            handler() {
                if (!this.add_subcomponents) {
                    this.sub_selected = false;

                }
            },
            deep: true,
        },
    },
};
</script>
<style lang=""></style>
